import React from "react";
import { TEXT_DIM } from "./tokens";

const PATHS: Record<string, React.ReactNode> = {
  search: (
    <>
      <circle cx="9" cy="9" r="5.5" />
      <path d="M13.2 13.2L17 17" />
    </>
  ),
  close: <path d="M5 5l10 10M15 5L5 15" />,
  chev: <path d="M7 4.5l5.5 5.5L7 15.5" />,
  chevd: <path d="M4.5 7.5l5.5 5.5 5.5-5.5" />,
  check: <path d="M4 10.5l4 4 8-8.5" />,
  sliders: (
    <>
      <path d="M3 6h14M3 10h14M3 14h14" />
      <circle cx="7" cy="6" r="1.6" fill="#fff" />
      <circle cx="13" cy="10" r="1.6" fill="#fff" />
      <circle cx="8.5" cy="14" r="1.6" fill="#fff" />
    </>
  ),
};

export type MobileIconName = keyof typeof PATHS;

/**
 * The small stroke icon set of the mobile kit (20x20 viewBox, 1.6 stroke),
 * traced from the same set the inventory-web list kit uses.
 */
export const Icon: React.FC<{ name: MobileIconName | string; color?: string; size?: number }> = ({
  name,
  color = TEXT_DIM,
  size = 20,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    stroke={color}
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ flex: "none", color }}
    aria-hidden="true"
  >
    {PATHS[name] ?? null}
  </svg>
);

export default Icon;
